import FeatureGates from '@atlaskit/feature-gate-js-client';

export const isOnboardingExpEnabled = (shouldTrackExposureEvent: boolean = true): boolean =>
	FeatureGates.checkGate('cc_onboarding_experience', {
		fireGateExposure: shouldTrackExposureEvent,
	});
